import { render, staticRenderFns } from "./BoolButton.vue?vue&type=template&id=67dacdac&"
import script from "./BoolButton.vue?vue&type=script&lang=js&"
export * from "./BoolButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports